import { IForm } from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      label: 'userid',
      field: 'userid',
      type: 'input',
      placeholder: '请输入userid',
    },
    {
      field: 'qyId',
      type: 'select',
      label: '企业',
      placeholder: '请选择企业',
      filterable: true,
      clearable: true,
      options: []
    },
    {
      label: '企业微信状态',
      field: 'status',
      type: 'select',
      clearable: true,
      placeholder: '请选择企业微信状态',
      options: [
        {title: '已激活', value: '1'},
        {title: '禁用', value: '2'},
        {title: '未激活', value: '4'},
        {title: '成员退出', value: '5'}
      ]
    },
    {
      label: '退出时间',
      field: 'quitTime',
      type: 'datepicker',
      otherOptions: {
        startPlaceholder: '',
        endPlaceholder: '',
        type: 'daterange',
        'value-format': 'YYYY-MM-DD'
      }
    },
    {
      label: '使用人',
      field: 'usedBy',
      type: 'select',
      filterable: true,
      clearable: true,
      placeholder: '请选择使用人'
    },
    {
      label: '使用人部门',
      field: 'usedByDept',
      type: 'select',
      filterable: true,
      clearable: true,
      placeholder: '请选择使用人部门'
    }
  ]
}
